import axios from "axios";
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const readAllCategoryList = async () => {
  const { data } = await axios.get(`${baseUrl}/productCategory/level`);
  return data;
};

const readCategoryList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productCategory/read`, {
    params: param,
  });
  return data;
};

const readNutrientList = async () => {
  const { data } = await axios.get(`${baseUrl}/admin/nutrientCategoryList`);
  return data;
};

const readSellerList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productSeller/list`, {
    params: param,
  });
  return data;
};

const readBrandListNotIncluded = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productBrand/list/notIncluded`,
    param,
  );
  return data;
};

const readBrandList = async (seller_id) => {
  const { data } = await axios.get(
    `${baseUrl}/productBrand/list?seller_id=${seller_id}`,
  );
  return data;
};

const readBrandListForSearch = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productBrand/search/admin`, {
    params: param,
  });
  return data;
};

const createBrandListWithExcel = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productBrand/create/admin`,
    param,
  );
  return data;
};

const readProductCntByStatus = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productItem/productStatus`, {
    params: param,
  });
  return data;
};

const readProductList = async ({
  product_id,
  product_maker_name,
  product_name,
  product_brand_name,
  product_status,
  // category1,
  category2,
  category3,
  orderType,
  orderBy,
  offset,
  pageSize,
  userId,
}) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/list?offset=${offset}&pageSize=${pageSize}&product_id=${product_id}&product_maker_name=${product_maker_name}&product_name=${product_name}&product_brand_name=${product_brand_name}&product_status=${product_status}&category2=${category2}&category3=${category3}&orderType=${orderType}&orderBy=${orderBy}&userId=${userId}`,
  );
  return data;
};

const readProductListNotIncluded = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/productList/notIncluded`,
    param,
  );
  return data;
};

const readProductListAll = async (
  product_id,
  product_maker_name,
  product_name,
  product_brand_name,
  orderType,
  orderBy,
  userId,
) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/productList/all?product_id=${product_id}&product_maker_name=${product_maker_name}&product_name=${product_name}&product_brand_name=${product_brand_name}&orderType=${orderType}&orderBy=${orderBy}&userId=${userId}`,
  );
  return data;
};

const readRelatedProductListWithoutIdList = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/relatedProduct/withoutRelatedProductIdList`,
    param,
  );
  return data;
};

const readRelatedProductListAppliedCoupon = async (param) => {
  const { data } = await axios.post(
    `${baseUrl}/productItem/relatedProduct/appliedCoupon`,
    param,
  );
  return data;
};

const readProductOptionList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/productItem/option/search`, {
    params: param,
  });
  return data;
};

const readProduct = async (productId, userId) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/readById?productId=${productId}&userId=${userId}`,
  );
  return data;
};

const createProduct = async (product) => {
  const { data } = await axios.post(`${baseUrl}/productItem/create`, product);
  return data;
};

const editProduct = async (param) => {
  const { data } = await axios.post(`${baseUrl}/productItem/edit`, param);
  return data;
};

const deleteRelatedProduct = async (
  main_product_id,
  related_product_id,
  user_id,
) => {
  const { data } = await axios.get(
    `${baseUrl}/productItem/relatedProduct/delete?main_product_id=${main_product_id}&related_product_id=${related_product_id}&user_id=${user_id}`,
  );
  return data;
};

const productApi = {
  readAllCategoryList,
  readCategoryList,
  readNutrientList,
  readSellerList,
  readBrandListNotIncluded,
  readBrandList,
  readBrandListForSearch,
  createBrandListWithExcel,
  readProductCntByStatus,
  readProductList,
  readProductListNotIncluded,
  readProductListAll,
  readRelatedProductListWithoutIdList,
  readRelatedProductListAppliedCoupon,
  readProductOptionList,
  readProduct,
  createProduct,
  editProduct,
  deleteRelatedProduct,
};

export default productApi;
